var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-assembly-table',{attrs:{"formData":_vm.formData,"columns":_vm.columns,"data":_vm.data,"total":_vm.total,"settings":_vm.settings,"loading":_vm.loading,"currentPage":_vm.current,"pageSize":_vm.pageSize},on:{"onSubmit":_vm.onSubmit,"onPageSizeChange":_vm.onPageSizeChange,"onCurrentPageChange":_vm.onCurrentPageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }